"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const js_1 = require("@mdi/js");
const react_2 = __importDefault(require("@mdi/react"));
const react_router_dom_1 = require("react-router-dom");
const FileExtension_1 = __importDefault(require("./FileExtension"));
function Menu({ columns, elements }) {
    const { url } = react_router_dom_1.useRouteMatch();
    const colSize = () => {
        switch (columns) {
            case 1:
                return "is-12";
            case 2:
                return "is-6";
            case 3:
                return "is-4";
            case 4:
                return "is-3";
            case 5:
                return "is-one-fifth";
            case 6:
                return "is-2";
            default:
                return "is-12";
        }
    };
    return (react_1.default.createElement("div", { className: "columns is-multiline is-mobile" }, elements.map((el, i) => (react_1.default.createElement(react_1.default.Fragment, { key: el.title + i }, el.url ? (react_1.default.createElement("div", { className: `column ${colSize()}-tablet is-12-mobile ${el.inactive ? "is-disabled" : "is-clickable"}` },
        react_1.default.createElement(react_router_dom_1.Link, { to: `${url}/${el.url}` },
            react_1.default.createElement(ContentComponent, { el: el })))) : (react_1.default.createElement("div", { className: "column is-6-mobile" },
        react_1.default.createElement(ContentComponent, { el: el }))))))));
}
exports.default = Menu;
function ContentComponent({ el }) {
    if (el.isImage)
        return (react_1.default.createElement("div", { className: "has-border2 border-radius-small border-color-black60 is-flex is-flex-direction-column menu-image is-relative" },
            react_1.default.createElement("img", { src: el.isImage, alt: "", className: "menu-image-hide" }),
            react_1.default.createElement("div", { className: "menu-image-hover" },
                react_1.default.createElement(FileExtension_1.default, { title: el.title, size: el.size })),
            react_1.default.createElement("div", { className: "menu-image-hide" },
                react_1.default.createElement(FileExtension_1.default, { title: el.title }))));
    else
        return (react_1.default.createElement("div", { className: `has-border2 border-radius-small is-flex is-align-items-center p-4 has-text-black has-text-weight-medium ${el.inactive
                ? "border-color-inactive has-background-transparent"
                : el.completed
                    ? "border-color-completed has-background-white"
                    : "border-color-normal has-background-white border-color-black60"}` },
            el.completed && (react_1.default.createElement("figure", { className: "is-flex is-justify-content-center is-align-items-center image is-32x32 has-background-completed border-radius-small mr-4" },
                react_1.default.createElement("figure", { className: "image is-16x16" },
                    react_1.default.createElement(react_2.default, { path: js_1.mdiCheck, color: "white" })))),
            el.inactive && !el.completed && (react_1.default.createElement("figure", { className: "is-flex is-justify-content-center is-align-items-center image is-32x32 has-background-inactive border-radius-small mr-4" },
                react_1.default.createElement("figure", { className: "image is-16x16" },
                    react_1.default.createElement(react_2.default, { path: js_1.mdiMinus, color: "white" })))),
            react_1.default.createElement("p", { className: "mr-4 py-2" }, el.title),
            react_1.default.createElement("p", null, el.desc),
            el.icon && !el.inactive && (react_1.default.createElement("figure", { className: "image is-24x24 ml-auto" },
                react_1.default.createElement(react_2.default, { path: el.icon }))),
            el.inactive && (react_1.default.createElement("span", { className: "ml-auto has-text-black40" }, "INACTIVE"))));
}
//# sourceMappingURL=Menu.js.map